import { MOCK_REQ_HANDLER } from '@acaprojects/ngx-composer';

import { MapObject } from '../utilities/types.utilities';
import { generateMockSpace } from '../../services/data/spaces/space.utilities';

import { generateMockUser } from '../../services/data/users/user.utilities';
import { MOCK_SPACES } from './spaces.mock';

declare global {
    interface Window {
        control: {
            systems: {
                [system_id: string]: IMockEngineSystem;
            };
        };
    }
}

interface IMockEngineSystem {
    id?: string;
    name?: string;
    [module: string]: MapObject[] | string;
}

export interface IBookingPanelBindings {
    /** Whether user input is enabled */
    touch_enabled: boolean;
    /** Number of seconds before a meeting can be started, being truthy enables start/stop and auto-cancellations */
    timeout?: number;
    /** Number of seconds after the start of a meeting when it is auto-cancelled, overrides `timeout` value */
    cancel_timeout?: number;
    /** Display directional arrow on the given side */
    arrow_direction?: 'left' | 'right';
    /** Whether to display hearing assistance UI elements */
    has_accessability?: boolean;
    /** Whether to display control UI elements */
    has_control?: boolean;
    /** URL to embed into the control modal when opened */
    control_url?: string;
    /** Whether to display catering UI elements */
    has_catering?: boolean;
    /** Whether to hide booking details(title and host) */
    hide_details?: boolean;
    /** Whether to hide timeline availability */
    hide_availability?: boolean;
    /** Whether to hide user(host) details */
    hide_user?: boolean;
    /** Whether to disable booking from the UI */
    booking_disabled?: boolean;
    /** Whether to hide the title of the displayed bookings */
    hide_title?: boolean;
    /** Whether to hide the body of the displayed bookings */
    hide_description?: boolean;
    /** Whether a new booking needs a host for requests */
    needs_host?: boolean;
    /** Whether a new booking needs a title for requests */
    needs_title?: boolean;
    /** Whether a new booking needs a user identifier for requests */
    needs_user_id?: boolean;
    /** Whether user search is enabled for selecting hosts */
    can_search_user?: boolean;
    /** Whether booking future meetings are allowed */
    no_future_bookings?: boolean;
    /** Minimum bookable duration in minutes */
    min_duration?: number;
    /** Maximum bookable duration in minutes */
    max_duration?: number;
    /** Whether bookings are endable after a booking is started */
    is_endable?: boolean;
    /** Whether to automatically ask user about cancellation */
    ask_cancel?: boolean;
    /** Whether to automatically ask user about ending the active meeting */
    ask_end?: boolean;
    /** Default meeting title if the displayed meeting doesn't have one */
    default_title?: boolean;
    /** Hide all meeting related details */
    hide_all?: boolean;
    /** URL of an icon image to display on the UI */
    icon?: string;
    /** Title of the active space */
    title?: string;
    /** Description of the active space */
    description?: string;
    /** Whether the space status is displayed on the right */
    flip_status?: boolean;
}

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const NUMBERS = '0123456789'.split('');

let index = 0;

const SPACE_LIST: any[] = [];

/**
 * Create mock engine booking module with appropriate bookings and space data
 */
function createSystem(): IMockEngineSystem {
    const id = `sys-${LETTERS[Math.floor(index / NUMBERS.length)]}${NUMBERS[index++ % NUMBERS.length]}`;
    const space = generateMockSpace(id);
    SPACE_LIST.push(space);
    const bindings: IBookingPanelBindings = {
        touch_enabled: true,
        has_control: true,
        has_catering: true,
        control_url: 'https://aca.im/demo/aca/control/'
    };
    const system = {
        id,
        name: space.name,
        Bookings: [
            {
                ...bindings,
                room_name: space.name,
                today: space.bookings
            }
        ]
    };
    return system;
}

export const MOCK_SYSTEMS = Array(10)
    .fill(0)
    .map(i => createSystem());

if (!window.control) {
    window.control = { systems: {} };
}
window.control.systems = MOCK_SYSTEMS.reduce((a: { [module: string]: IMockEngineSystem }, v) => {
    a[v.id] = v;
    return a;
}, {});

const USER_LIST = Array(10)
    .fill(0)
    .map(i => generateMockUser());



setTimeout(() => {
    MOCK_REQ_HANDLER.unregister('/control/api/systems');
    MOCK_REQ_HANDLER.register('/control/api/systems', { total: 10, results: MOCK_SYSTEMS });
    MOCK_REQ_HANDLER.register('/api/staff/rooms', MOCK_SPACES);
    MOCK_REQ_HANDLER.register('/api/staff/users', USER_LIST);
    MOCK_REQ_HANDLER.register('/control/api/users/current', USER_LIST[0]);
});
